import { Global } from '@utils/common';
import { ID } from './ID';

export const qualQuestionTypes = () => ({
  SINGLE_NUMERIC_QUESTION_TYPE: Global?.line_items?.single_numeric_question_type || 'single_numeric',
  SINGLE_TEXT_QUESTION_TYPE: Global?.line_items?.single_text_question_type || 'single_text', // fallback fixes units
  YES_NO_QUESTION_TYPE: Global?.line_items?.yes_no_question_type || 'yes_no'
} as const);

// Every Yes/No question shares the seeded `answer_options` rows (bidops-app db/seeds.rb).
export const YES_ANSWER = 1;
export const NO_ANSWER = 2;

export type QualQuestionType = ReturnType<typeof qualQuestionTypes>[
  keyof ReturnType<typeof qualQuestionTypes>
];

export const getQualQuestionTypes = (): QualQuestionType[] =>
  Object.values(qualQuestionTypes());

export const getTextQualQuestionType = (): QualQuestionType =>
  qualQuestionTypes().SINGLE_TEXT_QUESTION_TYPE;

export const getNumericQualQuestionType = (): QualQuestionType =>
  qualQuestionTypes().SINGLE_NUMERIC_QUESTION_TYPE;

export const getYesNoQualQuestionType = (): QualQuestionType =>
  qualQuestionTypes().YES_NO_QUESTION_TYPE;

export const validSupplierLIQTypes = new Set([
  getTextQualQuestionType(),
  getNumericQualQuestionType(),
  getYesNoQualQuestionType()
]);

export interface QualQuestionAppliedState {
  group_id: ID;
  is_applied: boolean;
}

export interface QualQuestionAnswerOption {
  [key: string]: any;
  answer_option_weight: any | null;
  answer_option_weight_id: string | null;
  qual_question_id: string;
}

export interface QualQuestion {
  _destroy?: boolean;
  character_limit?: number;
  id: ID;
  is_applied: boolean;
  is_required: boolean;
  order_index: number;
  question_type: string;
  questionable_type: string;
  text: string;
}

export interface ExtendedQualQuestion extends QualQuestion {
  answer_options: any[];
  group_id: ID;
  qual_question_answer_options: QualQuestionAnswerOption[];
  questionable_id: ID;
  questionable_parent_id?: ID;
  visible?: boolean;
}
